import Vue from 'vue' //引入Vue
import Router from 'vue-router' //引入vue-router
import home from '../home/home' //引入根目录下的Hello.vue组件
import Bossspeak from '../Boss-speak'
import worktrend from '../worktrend'
import Personnel from '../Personnel'
import laws from '../laws'
import contact from '../contact'
import details from '../details'
import material from '../material'
import serve from '../serve'
import userhome from '../userhome'
import morezx from '../morezx'

Vue.use(Router) //Vue全局使用Router

export default new Router({
	mode:'history',
	routes: [ //配置路由，这里是个数组
		{ //每一个链接都是一个对象
			path: '/', //链接路径
			name: 'home', //路由名称，
			component: home //对应的组件模板
		},
		{
			path: '/Bossspeak/:page', //机构概况
			name: 'Bossspeak',
			component: Bossspeak
		},
		{
			path: '/worktrend/:page', //公证动态
			name: 'worktrend',
			component: worktrend
		},
		{
			path: '/Personnel', //公证员风采
			name: 'Personnel',
			component: Personnel
		},
		{
			path: '/laws/:page', //法律法规
			name: 'laws',
			component: laws
		},
		{
			path: '/contact', //联系我们
			name: 'contact',
			component: contact
		},
		{
			path: '/details/:type/:id', //详情
			name: 'details',
			component: details
		},
		{
			path: '/material/:page', //详情
			name: 'material',
			component: material
		},
		{
			path: '/serve/:page', //详情
			name: 'serve',
			component: serve
		},
		{
			path: '/userhome/:page', //详情
			name: 'userhome',
			component: userhome
		},
		{
			path: '/morezx', //详情
			name: 'morezx',
			component: morezx
		},
	]
})
